import React from 'react';
import {Container, Divider, Header, Icon, Modal, ModalContent, Segment} from 'semantic-ui-react';
import {cookiesEnabled} from '../../lib/helpers/cookiesEnabled.js';
import {useTranslator} from '../../lib/hooks/useTranslator.js';
import {i18n} from '../../lib/i18n.js';
import {DocumentTitle} from '../../elements/DocumentTitle/DocumentTitle.js';
import {Text} from '../../elements/Formatters/Texts/Texts.js';

export const NoCookiesOverlay = ({children}) => {
    const [t] = useTranslator('common');

    let content = null;

    if (!cookiesEnabled()) {
        content = (
            <>
                <DocumentTitle title={t('cookies_required')}/>
                <Modal open={true} dimmer={'blurring'}>
                    <ModalContent>
                        <Segment basic padded={'very'}>
                            <Header as={'h1'}>
                                <Icon name={'settings'}/>
                                <Header.Content>{i18n.t('errors.Cookies_required')}</Header.Content>
                            </Header>

                            <Divider hidden/>
                            <Container>
                                <Text size={'large'}>
                                    {i18n.t('errors.noCookies')}
                                </Text>
                            </Container>

                        </Segment>
                    </ModalContent>
                </Modal>
            </>);
    } else {
        content = children;
    }

    return (
        <>{content}</>);
};